export default Object.freeze({
  Kilometer: 'Kilometer',
  Mile: 'Mile',
})
